export default "/img/NA.c797fcb3a04a08759c9e1589b0f101ab.png";